import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import Profile from './Profile';

const ProfileWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Perfil',
            }}
        >
            <Profile />
        </ServicesChartsDataProvider>
    );
};

export default ProfileWrapper;
